
webpack.register(
    'modules/live-video-pop-out/leaderboard-mini/leaderboard-mini',
    function() {
        return import('modules/live-video-pop-out/leaderboard-mini/leaderboard-mini');
    },
    true
);